import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AccountRepository from "src/repository/Admin/AccountRepository";
import { getForbiddenResponseMessage } from "src/service/forbiddenResponseMessage";

export const getAccountList = createAsyncThunk('get_account_list', async (params) => {
    try {
        return await new AccountRepository().getAccountList(params)
    } catch (error) {
        return { accounts: [], total: 0, message: getForbiddenResponseMessage(error) }
    }
});

export const getAccountDetail = createAsyncThunk('get_account_detail', async (params) => {
    return await new AccountRepository().getAccountDetail(params)
});

export const getAccountUserList = createAsyncThunk('get_account_user_list', async (params) => {
    try {
        return await new AccountRepository().getAccountUserList(params)
    } catch (error) {
        return { data: { accountSpecificList: [], total: 0 }, message: getForbiddenResponseMessage(error) }
    }
});


const slice = createSlice({
    name: "Accounts",
    initialState: {
        totalRecords: 0,
        filteredRecords: 0,
        accountListMessage: '',
        totalAccountUser: 0,
        filteredAccountUsers: 0,
        accountUserListMessage: '',
        accountList: [],
        accountDetail: {},
        accountUserList: [],
    },
    reducers: {
        setAccountList: {
            reducer: (state, action) => {
                state.accountList = action.payload;
                state.accountListMessage = '';
                return state;
            },
        },
        setAccountListMessage: {
            reducer: (state, action) => {
                state.accountListMessage = action.payload;
                return state;
            },
        },
        setAccountUserListMessage: {
            reducer: (state, action) => {
                state.accountUserListMessage = action.payload;
                return state;
            },
        },
    },
    extraReducers: {
        [getAccountList.fulfilled]: (state, action) => {
            state.accountList = action.payload.accounts;
            state.filteredRecords = action.payload.accounts?.length;
            state.totalRecords = action.payload.total;
            state.accountListMessage = action.payload.message || '';
        },
        [getAccountDetail.fulfilled]: (state, { payload }) => {
            state.accountDetail = payload
        },
        [getAccountUserList.fulfilled]: (state, { payload }) => {
            state.accountUserList = payload.data?.accountSpecificList;
            state.totalAccountUser = payload.data?.total;
            state.filteredAccountUsers = payload.data?.accountSpecificList?.length;
            state.accountUserListMessage = payload.message || '';
        },
    },
});



export let { setAccountList, setAccountListMessage, setAccountUserListMessage } = slice.actions;

export default slice.reducer;
